import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Router = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path
                d="M30 27.5C30 28.8807 28.8807 30 27.5 30C26.1193 30 25 28.8807 25 27.5C25 26.1193 26.1193 25 27.5 25C28.8807 25 30 26.1193 30 27.5Z"
                fill={props.color ? props.color : "white"} />
            <path
                d="M23 27.5C23 28.8807 21.8807 30 20.5 30C19.1193 30 18 28.8807 18 27.5C18 26.1193 19.1193 25 20.5 25C21.8807 25 23 26.1193 23 27.5Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd"
                d="M26 6C22.7489 6 19.8065 7.01897 17.5979 8.66639C17.1552 8.9966 16.5286 8.90542 16.1984 8.46272C15.8682 8.02003 15.9594 7.39346 16.4021 7.06325C18.9703 5.1476 22.3359 4 26 4C29.6641 4 33.0297 5.1476 35.5979 7.06325C36.0406 7.39346 36.1318 8.02003 35.8016 8.46272C35.4714 8.90542 34.8448 8.9966 34.4021 8.66639C32.1935 7.01897 29.2511 6 26 6ZM26 10.6879C24.5042 10.6879 23.1375 11.1204 22.0493 11.8357C21.5877 12.139 20.9677 12.0108 20.6644 11.5493C20.361 11.0877 20.4892 10.4677 20.9507 10.1644C22.3695 9.2318 24.119 8.68788 26 8.68788C27.881 8.68788 29.6305 9.2318 31.0493 10.1644C31.5108 10.4677 31.639 11.0877 31.3356 11.5493C31.0323 12.0108 30.4123 12.139 29.9507 11.8357C28.8625 11.1204 27.4958 10.6879 26 10.6879ZM26 13C26.5523 13 27 13.4477 27 14V20H27.5C31.6421 20 35 23.3579 35 27.5C35 31.6421 31.6421 35 27.5 35H12.5C8.35786 35 5 31.6421 5 27.5C5 23.3579 8.35786 20 12.5 20H25V14C25 13.4477 25.4477 13 26 13ZM12.5 22C9.46243 22 7 24.4624 7 27.5C7 30.5376 9.46243 33 12.5 33H27.5C30.5376 33 33 30.5376 33 27.5C33 24.4624 30.5376 22 27.5 22H12.5Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Router;
